import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface DealerOwnership { id: number; dealerCode: string; dealerName: string; status: string; ownerUserId: number | null; ownerName: string | null }
export interface InsightTeamMember { userId: number; fullName: string; email: string }
export interface DealerTarget { id: number; dealerId: number; ownerUserId: number | null; periodYear: number; periodMonth: number | null; targetValue: number }
export interface DealerAchievementRow { dealerId: number; dealerCode: string; dealerName: string; ownerName: string | null; target: number; achieved: number; achievementPct: number }
export interface DealerAnalytics { year: number; rows: DealerAchievementRow[]; totals: { target: number; achieved: number; achievementPct: number } }

export const dealerInsightsApi = {
  async ownership(): Promise<{ dealers: DealerOwnership[]; teamMembers: InsightTeamMember[] }> {
    return (await apiClient.get<ApiSuccess<{ dealers: DealerOwnership[]; teamMembers: InsightTeamMember[] }>>('/dealer-insights/ownership')).data.data;
  },
  async setOwner(dealerId: number, ownerUserId: number | null): Promise<unknown> {
    return (await apiClient.put(`/dealer-insights/ownership/${dealerId}`, { ownerUserId })).data;
  },
  async listTargets(year?: number): Promise<DealerTarget[]> {
    return (await apiClient.get<ApiSuccess<DealerTarget[]>>('/dealer-insights/targets', { params: { year } })).data.data;
  },
  async createTarget(body: { dealerId: number; ownerUserId?: number | null; periodYear: number; periodMonth?: number | null; targetValue: number }): Promise<DealerTarget> {
    return (await apiClient.post<ApiSuccess<DealerTarget>>('/dealer-insights/targets', body)).data.data;
  },
  async updateTarget(id: number, targetValue: number): Promise<DealerTarget> {
    return (await apiClient.put<ApiSuccess<DealerTarget>>(`/dealer-insights/targets/${id}`, { targetValue })).data.data;
  },
  async removeTarget(id: number): Promise<void> { await apiClient.delete(`/dealer-insights/targets/${id}`); },
  async analytics(year: number): Promise<DealerAnalytics> {
    return (await apiClient.get<ApiSuccess<DealerAnalytics>>('/dealer-insights/analytics', { params: { year } })).data.data;
  },
};
